export { default } from './LostOpportunity';
